<div class='spinner-overlay' *ngIf='spinning'>
  <div class='background'></div>
  <ion-spinner class='spinner' name='circles'></ion-spinner>
</div>